export const pimProductsQuery = `
  query PimProductsQuery(
    $search: String,
    $productStyle: [QueryArgument],
    $productType: [QueryArgument],
    $productModel: [QueryArgument],
    $buildingType: [QueryArgument],
    $numBedrooms: [QueryArgument],
    $footprint: [QueryArgument],
    $usableArea: [QueryArgument],
    $maxLength: [QueryArgument],
    $maxWidth: [QueryArgument],
    $plotType: [QueryArgument],
    $numLevels: [QueryArgument],
    $roofType: [QueryArgument],
    $productProperties: [QueryArgument],
    $regulations: [QueryArgument],
    $productStatus: [QueryArgument]
    $orderBy: String,
    $limit: Int,
    $offset: Int,
  ) {
    products: entries(
      section: "products",
      search: $search,
      productStyle: $productStyle
      productType: $productType,
      productModel: $productModel,
      buildingType: $buildingType,
      numBedrooms: $numBedrooms,
      footprint: $footprint,
      usableArea: $usableArea,
      maxLength: $maxLength,
      maxWidth: $maxWidth,
      plotType: $plotType,
      roofType: $roofType,
      numLevels: $numLevels,
      productProperties: $productProperties,
      regulations: $regulations,
      productStatus: $productStatus,
      orderBy: $orderBy,
      limit: $limit,
      offset: $offset,
    ) {
      ... on product_Entry {
        id
        slug
        url
        title
        listingLabel
        numBedrooms
        footprint
        usableArea
        images {
          url @imagerTransform (handle: "productCard")
          alt
        }
      }
    }
    total: entryCount(
      section: "products",
      search: $search,
      productStyle: $productStyle
      productType: $productType,
      productModel: $productModel,
      buildingType: $buildingType,
      numBedrooms: $numBedrooms,
      footprint: $footprint,
      usableArea: $usableArea,
      maxLength: $maxLength,
      maxWidth: $maxWidth,
      plotType: $plotType,
      numLevels: $numLevels,
      roofType: $roofType,
      productProperties: $productProperties,
      regulations: $regulations,
      productStatus: $productStatus
    )
  }
`;

export const pimFiltersQuery = `
  query PimFiltersQuery(
    $search: String,
    $productStyle: [QueryArgument],
    $productType: [QueryArgument],
    $productModel: [QueryArgument],
    $buildingType: [QueryArgument],
    $numBedrooms: [QueryArgument],
    $footprint: [QueryArgument],
    $usableArea: [QueryArgument],
    $maxLength: [QueryArgument],
    $maxWidth: [QueryArgument],
    $plotType: [QueryArgument],
    $numLevels: [QueryArgument],
    $roofType: [QueryArgument],
    $productProperties: [QueryArgument],
    $regulations: [QueryArgument],
    $productStatus: [QueryArgument]
  ) {
    products: entries(
      section: "products",
      search: $search,
      productStyle: $productStyle
      productType: $productType,
      productModel: $productModel,
      buildingType: $buildingType,
      numBedrooms: $numBedrooms,
      footprint: $footprint,
      usableArea: $usableArea,
      maxLength: $maxLength,
      maxWidth: $maxWidth,
      plotType: $plotType,
      numLevels: $numLevels,
      productProperties: $productProperties,
      roofType: $roofType,
      regulations: $regulations,
      productStatus: $productStatus
    ) {
      ... on product_Entry {
        id
        productStyle {
          id
          title
        }
        productType {
          id
          title
        }
        productModel {
          id
          title
        }
        buildingType {
          id
          title
        }
        plotType {
          id
          title
        }
        roofType {
          id
          title
        }
        productProperties {
          id
          title
        }
        regulations {
          id
          title
        }
        productStatus {
          id
          title
        }
        numBedrooms
        footprint
        usableArea
        maxLength
        maxWidth
        numLevels
      }
    }
    filterSections: categories(group: "productFilters") {
      ... on productFilters_Category {
        id
        title
        filterType
        max: maxNumber
        min: minNumber
        defaultValue: defaultType {
          id
          title
        }
        productFieldHandle
        tooltip
        categoryGroup
      }
    }
    productStyles: categories(group: "productStyles") {
      ... on productStyles_Category {
        id
        title
      }
    }
    productTypes: categories(group: "productTypes") {
      ... on productTypes_Category {
        id
        title
      }
    }
    models: categories(group: "models") {
      ... on models_Category {
        id
        title
      }
    }
    buildingTypes: categories(group: "buildingTypes") {
      ... on buildingTypes_Category {
        id
        title
      }
    }
    plotTypes: categories(group: "plotTypes") {
      ... on plotTypes_Category {
        id
        title
      }
    }
    roofTypes: categories(group: "roofTypes") {
      ... on roofTypes_Category {
        id
        title
      }
    }
    regulations: categories(group: "regulations") {
      ... on regulations_Category {
        id
        title
      }
    }
    productProperties: categories(group: "productProperties") {
      ... on productProperties_Category {
        id
        title
      }
    }
    productStatuses: categories(group: "productStatuses") {
      ... on productStatuses_Category {
        id
        title
      }
    }
  }
`;
